module.exports = __webpack_public_path__ + "static/media/Saint Vincent and the Grenadines.e6d9c12e.png";